export const environment = {
  production: false,
  call_host: 'https://dev.matrixcall.canstringai.com',
  email_host: 'https://dev.matrixemail.canstringai.com',
  excel_host: 'https://devgpt.absenceassistance.com',
  base_login: 'call',
  csrfCookieName: 'uat_csrf_access_token',
};
